/**
 * Human labels for membership vacuum-minute and vending-credit benefits.
 * Cap semantics mirror the backend (routes/subscriptions.ts isUnlimitedCap):
 * cap <= 0 = unlimited, null = the plan doesn't include that axis at all.
 * Customers must see these benefits anywhere a plan is shown or purchasable.
 */

/** "Includes 30 vac min/day, 200/mo" / "Includes unlimited vac minutes" / null. */
export function vacMinutesLabel(
  day: number | null | undefined,
  month: number | null | undefined,
): string | null {
  if (day == null && month == null) return null;
  const unlimitedDay = day != null && day <= 0;
  const unlimitedMonth = month != null && month <= 0;
  if ((day == null || unlimitedDay) && (month == null || unlimitedMonth)) {
    return 'Includes unlimited vac minutes';
  }
  const parts: string[] = [];
  if (day != null && !unlimitedDay) parts.push(`${day} vac min/day`);
  if (month != null && !unlimitedMonth) {
    parts.push(parts.length > 0 ? `${month}/mo` : `${month} vac min/mo`);
  }
  return `Includes ${parts.join(', ')}`;
}

/** "$5.00/mo vending credit" or null when the plan has none. */
export function vendingCreditLabel(cents: number | null | undefined): string | null {
  if (cents == null || cents <= 0) return null;
  return `$${(cents / 100).toFixed(2)}/mo vending credit`;
}
